/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import './styles/CommentRow.scss';

const CommentRow = ({ comments }) => (
  <tr className='contact-list-comment-row'>
    <td className='contact-list-comment-row__table-data-cell' colSpan={17}>
      {comments.map(comment => (
        <div key={comment.reader} className='contact-list-comment-row__comments'>
          <h3 className='contact-list-comment-row__header'>
            Comments by&nbsp;
            {comment.reader}
          </h3>
          {comment.comments.map(({ field_name, text }) => (
            <div key={field_name} className='contact-list-comment-row__comment-row'>
              <div className='contact-list-comment-row__field-name'>{field_name}</div>
              <div className='contact-list-comment-row__comment-text'>{text}</div>
            </div>
          ))}
        </div>
      ))}
    </td>
  </tr>
);

CommentRow.propTypes = {
  /** Comments to render in comment row */
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      comments: PropTypes.arrayOf(
        PropTypes.shape({
          field_name: PropTypes.string,
          text: PropTypes.string
        })
      ),
      reader: PropTypes.string
    })
  )
};

CommentRow.defaultProps = {
  comments: []
};

export default CommentRow;
